/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import React from 'react'
import {Modal, Select} from '@scuf/common';
import {injectIntl, FormattedMessage} from 'react-intl';
import {changeLanguage, getCurrentLanguage} from '../utils/Helpers'
import {SUPPORTED_LANGUAGES} from "../utils/Const";
import {isAuthenticated} from '../api/HttpUtils'
import {setUserLanguage} from "../api/Security";
import connect from "react-redux/es/connect/connect";
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";

class LanguagePicker extends React.Component {
    constructor(props) {
        super(props);

        this.changeLanguage = this.changeLanguage.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.openModal = this.openModal.bind(this)
    }

    state = {
        modalOpen: false,
    }

    changeLanguage(lang) {
        //if user is authenticated persist language settings into DB
        if (isAuthenticated()) {
            if (userHasActivity(this.props.security.userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
                setUserLanguage(this.props.security.userProfile.id, lang).then(() => changeLanguage(lang+ '_hda'))
            } else {
                setUserLanguage(this.props.security.userProfile.id, lang).then(() => changeLanguage(lang))
            }
        } else {
            changeLanguage(lang)
        }
        this.setState({modalOpen: false})
    }

    closeModal() {
        this.setState({modalOpen: false})
    }

    openModal() {
        this.setState({modalOpen: true})
    }

    render() {
        let currentLang = SUPPORTED_LANGUAGES.filter(l => l.code === getCurrentLanguage())[0];
        if (!currentLang) {
            currentLang = SUPPORTED_LANGUAGES[0];
        }
        return (
            <span className="clickable" >
                {this.renderLangModal()}
                <span className="language-picker-trigger" onClick={this.openModal}>
                    {currentLang.name}
                </span>

            </span>
        )
    }

    renderLangModal() {
        const { intl } = this.props
        const languages = []
        return (
            <Modal size="small" closeIcon={true} onClose={this.closeModal}
                   open={this.state.modalOpen} closeOnDimmerClick={false} closeOnDocumentClick={false}>
                <Modal.Header>
                    <FormattedMessage id="lang.select" />
                </Modal.Header>
                <Modal.Content>
                    {SUPPORTED_LANGUAGES.map(l => {
                        languages.push({value: l.code, text: l.name})
                    })}
                    <div>
                        <Select
                            label={intl.formatMessage({id:"lang.selectLabel"})}
                            fluid search={true}
                            placeholder={intl.formatMessage({id:"lang.selectPlaceholder"})}
                            options={languages} onChange = {(value)=> (this.changeLanguage(value))} />
                        <br/><br/><br/><br/><br/>
                    </div>
                </Modal.Content>
            </Modal>
        )
    }
}

const mapStateToProps= state => {
    return {
        security: state.security,
    };
};

export default injectIntl(connect(mapStateToProps)(LanguagePicker))